import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SEO, { schemas } from '../components/SEO';
import {
  StatsBar, About, Capabilities,
  Services, CtaStrip, OWASPSection, Workflow
} from '../components/Sections';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

export default function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); observer.unobserve(e.target); }
      }),
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <SEO
        title="Where AI Meets Reality"
        description="Accugen is an enterprise-grade platform for evaluating AI chatbot quality, detecting vulnerabilities, and ensuring full OWASP LLM Top 10 compliance — from a single unified dashboard."
        canonical="/"
        keywords="AI evaluation platform, LLM security testing, OWASP LLM Top 10, AI chatbot quality, bias detection, hallucination detection, enterprise AI governance"
        schema={schemas.softwareApp()}
      />

      <Header />
      <Hero />
      <StatsBar />
      <About />
      <Capabilities />
      <Services />
      <CtaStrip />
      <OWASPSection />
      <Workflow />
      <ContactSection />
      <Footer />
    </>
  );
}
